var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare64AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M51 30.5a1.5 1.5 0 0 0-1.5-1.5h-19a1.5 1.5 0 0 0-1.5 1.5v19a1.5 1.5 0 0 0 1.5 1.5h19a1.5 1.5 0 0 0 1.5-1.5v-19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.5 62.5A2.5 2.5 0 0 0 37 60H25.5a2.5 2.5 0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h14V62.5ZM40.5 17.5A2.5 2.5 0 0 0 43 20h11.5a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 54.5 5h-14v12.5ZM57 62.5a2.5 2.5 0 0 0-2.5-2.5H43a2.5 2.5 0 0 0-2.5 2.5V75h14a2.5 2.5 0 0 0 2.5-2.5v-10ZM23 17.5a2.5 2.5 0 0 0 2.5 2.5H37a2.5 2.5 0 0 0 2.5-2.5V5h-14A2.5 2.5 0 0 0 23 7.5v10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M57 65v7.5a2.5 2.5 0 0 1-2.5 2.5h-29a2.5 2.5 0 0 1-2.5-2.5V65M23 15V7.5A2.5 2.5 0 0 1 25.5 5h29A2.5 2.5 0 0 1 57 7.5V15"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 40,
  r: 7,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  transform: "rotate(180 68 40)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.5 32a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 5 45.5v-11A2.5 2.5 0 0 1 7.5 32h10Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M15 32H7.5A2.5 2.5 0 0 0 5 34.5v11A2.5 2.5 0 0 0 7.5 48H15"
})));
SvgSquare64AError.viewBox = '0 0 80 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare64AError);
export default ForwardRef;